import { useQuery } from '@tanstack/react-query';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { classesPendingSummaryTotalQueries } from '../query-keys/classesPendingSummaryTotalQueryKey';
import { useSingleCache } from './query/v2/useCacheManager';

const useClassesPendingSummaryTotal = () => {
  const pendingSummaryQueryKey = classesPendingSummaryTotalQueries.get();
  const { data: pendingCount, isInitialLoading: isLoading } = useQuery({
    ...pendingSummaryQueryKey,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache(pendingSummaryQueryKey.queryKey);

  return {
    pendingSummaryQueryKey,
    pendingCount,
    isLoading,
    cache,
  };
};

export default useClassesPendingSummaryTotal;
